/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DisabledFeatureFlagsResponseDto } from '../models';
/**
 * RestFeatureFlagsApi - axios parameter creator
 * @export
 */
export const RestFeatureFlagsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Zwraca listę feature flag, które są aktualnie **wyłączone**. Jeśli flaga znajduje się na liście, front powinien ukryć powiązany feature. Flagi nieobecne w liście są traktowane jako włączone. 
         * @summary Pobierz listę wyłączonych feature flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDisabledFeatureFlags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/feature-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestFeatureFlagsApi - functional programming interface
 * @export
 */
export const RestFeatureFlagsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestFeatureFlagsApiAxiosParamCreator(configuration)
    return {
        /**
         * Zwraca listę feature flag, które są aktualnie **wyłączone**. Jeśli flaga znajduje się na liście, front powinien ukryć powiązany feature. Flagi nieobecne w liście są traktowane jako włączone. 
         * @summary Pobierz listę wyłączonych feature flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDisabledFeatureFlags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisabledFeatureFlagsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDisabledFeatureFlags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestFeatureFlagsApi.getDisabledFeatureFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestFeatureFlagsApi - factory interface
 * @export
 */
export const RestFeatureFlagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestFeatureFlagsApiFp(configuration)
    return {
        /**
         * Zwraca listę feature flag, które są aktualnie **wyłączone**. Jeśli flaga znajduje się na liście, front powinien ukryć powiązany feature. Flagi nieobecne w liście są traktowane jako włączone. 
         * @summary Pobierz listę wyłączonych feature flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDisabledFeatureFlags(options?: RawAxiosRequestConfig): AxiosPromise<DisabledFeatureFlagsResponseDto> {
            return localVarFp.getDisabledFeatureFlags(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestFeatureFlagsApi - interface
 * @export
 * @interface RestFeatureFlagsApi
 */
export interface RestFeatureFlagsApiInterface {
    /**
     * Zwraca listę feature flag, które są aktualnie **wyłączone**. Jeśli flaga znajduje się na liście, front powinien ukryć powiązany feature. Flagi nieobecne w liście są traktowane jako włączone. 
     * @summary Pobierz listę wyłączonych feature flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestFeatureFlagsApiInterface
     */
    getDisabledFeatureFlags(options?: RawAxiosRequestConfig): AxiosPromise<DisabledFeatureFlagsResponseDto>;

}

/**
 * RestFeatureFlagsApi - object-oriented interface
 * @export
 * @class RestFeatureFlagsApi
 * @extends {BaseAPI}
 */
export class RestFeatureFlagsApi extends BaseAPI implements RestFeatureFlagsApiInterface {
    /**
     * Zwraca listę feature flag, które są aktualnie **wyłączone**. Jeśli flaga znajduje się na liście, front powinien ukryć powiązany feature. Flagi nieobecne w liście są traktowane jako włączone. 
     * @summary Pobierz listę wyłączonych feature flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestFeatureFlagsApi
     */
    public getDisabledFeatureFlags(options?: RawAxiosRequestConfig) {
        return RestFeatureFlagsApiFp(this.configuration).getDisabledFeatureFlags(options).then((request) => request(this.axios, this.basePath));
    }
}

